import React, { useState } from 'react';
import Input from '../../../components/Input';
import Toask from '@/components/Toast';
import check from '@/utils/checkFrom';
import { connect } from 'dva';
import styles from './index.module.scss';

function EmailLoginForm({ onGoFindPwd, dispatch }) {
  const [formValue, setformValue] = useState({
    email: '',
    password: '',
    pwdType: 'password',
    setpwdType: () => {
      return setformValue((cur) => {
        return {
          ...cur,
          pwdType: cur.pwdType === 'text' ? 'password' : 'text',
        };
      });
    },
    onChangeEmail: ({ target: { value: email } }) => {
      setformValue((cur) => ({
        ...cur,
        email,
      }));
    },
    onChangePwd: ({ target: { value: password } }) =>
      setformValue((cur) => ({
        ...cur,
        password,
      })),
  });
  const checkForm = ({ email = '', password = '' }) => {
    const fd = check([
      {
        targetStr: email,
        rules: {
          isNull: {
            params: '請輸入郵箱號',
          },
        },
      },
      {
        targetStr: email,
        rules: {
          minLength: {
            params: [6, '郵箱長度不可以小於 6 位'],
          },
        },
      },
      {
        targetStr: email,
        rules: {
          checkFormat: {
            params: [
              /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
              '郵箱格式不正確',
            ],
          },
        },
      },
    ]);
    if (fd != true) {
      return fd;
    }

    return check([
      {
        targetStr: password,
        rules: {
          isNull: {
            params: '請輸入密碼',
          },
        },
      },
      {
        targetStr: password,
        rules: {
          minLength: {
            params: [6, '密碼長度不可以小於 6 位'],
          },
        },
      },
    ]);
  };
  const onLogin = () => {
    const state = checkForm({
      email: formValue.email,
      password: formValue.password,
    });
    if (state !== true) {
      Toask(state.msg);
      return;
    }

    dispatch({
      type: 'user/userOrEmailLogin',
      payload: {
        UserName: formValue.email,
        Password: formValue.password,
        // AccountType: 1
      },
    });
  };

  return (
    <div
      className={styles.content}
      onKeyDown={(e) => {
        if (e.keyCode === 13) onLogin();
      }}
    >
      <Input
        value={formValue.email}
        onChange={formValue.onChangeEmail}
        placeholder='請輸入郵箱'
      />
      <p className={styles.sdfsd}></p>
      <Input
        onClickIcon={formValue.setpwdType}
        getRightIcon={() => {
          return (
            <img
              src={
                require(`../image/${
                  formValue.pwdType == 'text' ? 'yj' : 'by'
                }.png`).default
              }
            />
          );
        }}
        onChange={formValue.onChangePwd}
        value={formValue.password}
        type={formValue.pwdType}
        placeholder='請輸入郵箱密碼'
      />
      <p className={styles.fsjido}>
        <span
          onClick={() => {
            // 忘记密码
            onGoFindPwd && onGoFindPwd();
          }}
          className={styles.forgetPwd}
        >
          忘記密碼?
        </span>
      </p>
      <div
        onClick={() => {
          onLogin();
        }}
        className={styles.btn_login}
      >
        登錄
      </div>
    </div>
  );
}
export default connect()(EmailLoginForm);
